export const dnsRecordInstructions = {
  SPF: {
    title: "SPF Record Setup Guide",
    type: "TXT",
    description:
      "SPF (Sender Policy Framework) helps prevent email spoofing by specifying which mail servers are authorized to send emails on behalf of your domain.",
    steps: [
      "1. Log in to your domain registrar or DNS hosting provider (e.g., GoDaddy, Cloudflare, Namecheap)",
      "2. Navigate to DNS Management or DNS Zone Editor",
      "3. Look for 'Add DNS Record' or 'Add New Record' button",
      "4. Select record type: TXT",
      "5. In the Host/Name field, enter: @ (this represents your root domain)",
      "6. In the Value/Content field, paste the SPF record shown above",
      "7. Set TTL (Time To Live) to 300 seconds (5 minutes) or use default",
      "8. Save the record",
    ],
    notes: [
      "⚠️ Only have ONE SPF record per domain",
      "⚠️ If you already have an SPF record, you need to modify it, not add a new one",
      "✅ DNS propagation typically takes 5-30 minutes",
      "✅ You can check propagation using online DNS checker tools",
    ],
  },
  DKIM: {
    title: "DKIM Verification — 3 CNAME Records (Amazon SES Easy DKIM)",
    type: "CNAME",
    description:
      "We use Amazon SES Easy DKIM: message signing is automatic once SES verifies your domain. You do not add a DKIM TXT record — instead publish three CNAME records so SES can prove domain ownership and enable signing.",
    steps: [
      "1. Log in to your domain registrar or DNS hosting provider",
      "2. Navigate to DNS Management or DNS Zone Editor",
      "3. Look for 'Add DNS Record' or 'Add New Record' button",
      "4. Select record type: CNAME (NOT TXT)",
      "5. For each of the three CNAMEs shown above, create one record:",
      "   • Host/Name: paste the value from the “Name / Host” field (without your domain — most DNS panels add it automatically)",
      "   • Value/Target/Points to: paste the CNAME target (e.g. <token>.dkim.amazonses.com)",
      "6. Set TTL to 300 seconds (5 minutes) or use default",
      "7. Save each record — you must publish ALL three before DKIM verification turns green",
    ],
    notes: [
      "🔑 No DKIM private keys on your side — SES manages 2048-bit keys and signs every outgoing message after verification",
      "⚠️ These are CNAME records, not TXT. If your DNS panel auto-appends the domain, use only the relative host (e.g. <token>._domainkey), not the full name with .yourdomain.com",
      '⚠️ If the saved host looks like "<token>._domainkey.yourdomain.com.yourdomain.com", remove the duplicate domain suffix',
      "⏱️ All three CNAMEs must resolve before SES marks DKIM as verified (usually 5–30 min)",
      "✅ After verification there is nothing else to configure — signing stays automatic",
    ],
  },
  DMARC: {
    title: "DMARC Record Setup Guide",
    type: "TXT",
    description:
      "DMARC (Domain-based Message Authentication, Reporting & Conformance) tells email providers what to do with emails that fail SPF or DKIM checks.",
    steps: [
      "1. Log in to your domain registrar or DNS hosting provider",
      "2. Navigate to DNS Management or DNS Zone Editor",
      "3. Look for 'Add DNS Record' or 'Add New Record' button",
      "4. Select record type: TXT",
      "5. In the Host/Name field, enter: _dmarc",
      "6. In the Value/Content field, paste the DMARC record shown above",
      "7. Set TTL to 300 seconds (5 minutes) or use default",
      "8. Save the record",
    ],
    notes: [
      "🛡️ DMARC requires both SPF and DKIM to be set up first",
      "📧 The record includes your email for receiving DMARC reports",
      "⚠️ p=quarantine means suspicious emails go to spam folder",
      "✅ DMARC significantly improves email deliverability",
    ],
  },
  BIMI: {
    title: "BIMI Record Setup Guide",
    type: "TXT",
    description:
      "BIMI (Brand Indicators for Message Identification) displays your logo next to emails in supported email clients.",
    steps: [
      "1. Log in to your domain registrar or DNS hosting provider",
      "2. Navigate to DNS Management or DNS Zone Editor",
      "3. Look for 'Add DNS Record' or 'Add New Record' button",
      "4. Select record type: TXT",
      "5. In the Host/Name field, enter: default._bimi",
      "6. In the Value/Content field, paste the BIMI record shown above",
      "7. Set TTL to 300 seconds (5 minutes) or use default",
      "8. Save the record",
    ],
    notes: [
      "🖼️ BIMI displays your logo in email clients that support it",
      "⚠️ Limited support - mainly works in Yahoo, Gmail (with VMC), and some others",
      "🏆 For Gmail, you need a VMC (Verified Mark Certificate) which requires a registered trademark",
      "✅ DMARC policy must be set to p=quarantine or p=reject (already configured)",
    ],
  },
};
